// extracted by mini-css-extract-plugin
export default {"ordersinfo":"OrdersInfo_ordersinfo__CDYoB","ordersboard":"OrdersInfo_ordersboard__9LJyl","ordersstatistic":"OrdersInfo_ordersstatistic__Trtbc"};